module.exports = "<list-view\n  title=\"Fines Reimbursements\"\n  transformer=\"FinesReimbursementsTransforms\"\n  resource=\"FineReimbursement\"\n  item-state=\"finereimbursement\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  filter-event=\"$ctrl.filterEvent\"\n  active-params=\"$ctrl.activeParams\"\n  no-items-text=\"No Fines Reimbursements Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\"></main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/finesReimbursements/finesReimbursements.html
// module id = 2225
// module chunks = 0